import PlanList from "@/components/plans/PlanList.vue";
import PlanDetail from "@/components/plans/PlanDetail.vue";

const planRoutes = [
  { path: "/plans", name: "plans", component: PlanList },
  { path: "/plans/:id", name: "plan-detail", component: PlanDetail },
];

export default planRoutes;
